// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"f987b425","673":"5996131b","903":"88b6a9e0"}[chunkId] + ".chunk.css";
};